/** First Round (theResume) helpers for the admin console. */

/** theResume tiers carry the First Round plan names. */
export const FIRST_ROUND_TIER_LABELS: Record<string, string> = {
  FREE: "Free",
  BASIC: "Starter",
  PRO: "Active",
};

export const tierName = (product: string, tier: string) =>
  (product === "THERESUME" && FIRST_ROUND_TIER_LABELS[tier]) || tier;

/** A plan sold as a pass (Starter, Active) has a length in days. */
export const isPassPlan = (plan: { accessDays?: number | null }) =>
  typeof plan.accessDays === "number" && plan.accessDays > 0;

/** The server's message from a failed admin request (its body is the error JSON). */
export const errorMessage = (error: unknown): string => {
  const raw = error instanceof Error ? error.message : String(error);
  try {
    const parsed = JSON.parse(raw);
    const message = Array.isArray(parsed.message) ? parsed.message.join(", ") : parsed.message;
    return message || raw;
  } catch {
    return raw;
  }
};

export const formatMoney = (amount: number | string, currency = "USD") => {
  const value = Number(amount);
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: Number.isInteger(value) ? 0 : 2,
  }).format(value);
};

export const formatDay = (value?: string | Date | null) =>
  value
    ? new Date(value).toLocaleDateString(undefined, {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : "—";
